var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 13,
    viewBox: "0 0 85 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40593 4.26198C4.53687 4.2482 4.64692 4.16832 4.70058 4.04783L6.50009 0L8.2996 4.04756C8.35295 4.16806 8.46301 4.24793 8.59425 4.26172L13 4.72229L9.70651 7.68458C9.60847 7.7726 9.56649 7.90197 9.59374 8.03114L10.5171 12.3634L6.68205 10.1464C6.56792 10.0804 6.43187 10.0806 6.31774 10.1464L2.48269 12.3634L3.40605 8.03114C3.43351 7.90208 3.39143 7.7725 3.29349 7.68469L0 4.72239L4.40593 4.26198Z",
    fill: "#F5CC26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4059 4.26198C22.5369 4.2482 22.6469 4.16832 22.7006 4.04783L24.5001 0L26.2996 4.04756C26.353 4.16806 26.463 4.24793 26.5943 4.26172L31 4.72229L27.7065 7.68458C27.6085 7.7726 27.5665 7.90197 27.5937 8.03114L28.5171 12.3634L24.6821 10.1464C24.5679 10.0804 24.4319 10.0806 24.3177 10.1464L20.4827 12.3634L21.406 8.03114C21.4335 7.90208 21.3914 7.7725 21.2935 7.68469L18 4.72239L22.4059 4.26198Z",
    fill: "#F5CC26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4059 4.26198C40.5369 4.2482 40.6469 4.16832 40.7006 4.04783L42.5001 0L44.2996 4.04756C44.353 4.16806 44.463 4.24793 44.5943 4.26172L49 4.72229L45.7065 7.68458C45.6085 7.7726 45.5665 7.90197 45.5937 8.03114L46.5171 12.3634L42.6821 10.1464C42.5679 10.0804 42.4319 10.0806 42.3177 10.1464L38.4827 12.3634L39.406 8.03114C39.4335 7.90208 39.3914 7.7725 39.2935 7.68469L36 4.72239L40.4059 4.26198Z",
    fill: "#F5CC26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4059 4.26198C58.5369 4.2482 58.6469 4.16832 58.7006 4.04783L60.5001 0L62.2996 4.04756C62.353 4.16806 62.463 4.24793 62.5943 4.26172L67 4.72229L63.7065 7.68458C63.6085 7.7726 63.5665 7.90197 63.5937 8.03114L64.5171 12.3634L60.6821 10.1464C60.5679 10.0804 60.4319 10.0806 60.3177 10.1464L56.4827 12.3634L57.406 8.03114C57.4335 7.90208 57.3914 7.7725 57.2935 7.68469L54 4.72239L58.4059 4.26198Z",
    fill: "#F5CC26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4059 4.26198C76.5369 4.2482 76.6469 4.16832 76.7006 4.04783L78.5001 0L80.2996 4.04756C80.353 4.16806 80.463 4.24793 80.5943 4.26172L85 4.72229L81.7065 7.68458C81.6085 7.7726 81.5665 7.90197 81.5937 8.03114L82.5171 12.3634L78.6821 10.1464C78.5679 10.0804 78.4319 10.0806 78.3177 10.1464L74.4827 12.3634L75.406 8.03114C75.4335 7.90208 75.3914 7.7725 75.2935 7.68469L72 4.72239L76.4059 4.26198Z",
    fill: "#F5CC26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.601d6e14a329d58114f28d04e4d2277f.svg";
export { ForwardRef as ReactComponent };